import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const navStyle = (isActive) => ({
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
  padding: '8px 16px', color: isActive ? '#6366f1' : '#64748b',
  fontWeight: isActive ? '700' : '400', fontSize: '11px', textDecoration: 'none',
  borderTop: isActive ? '2px solid #6366f1' : '2px solid transparent',
  background: 'none', border: 'none', cursor: 'pointer'
});

export default function Layout({ children, onLogout }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', paddingBottom: '70px' }}>
      <div style={{ background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>🛒 Einkauf & Vorrat</span>
        <button onClick={onLogout} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '8px', cursor: 'pointer' }}>Logout</button>
      </div>
      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '16px' }}>{children}</div>
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-around', zIndex: 100 }}>
        <NavLink to="/" end style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: '20px' }}>🛒</span>Listen</NavLink>
        <NavLink to="/vorrat" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: '20px' }}>📦</span>Vorrat</NavLink>
        <NavLink to="/reports" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: '20px' }}>📊</span>Reports</NavLink>
        <NavLink to="/einstellungen" style={({ isActive }) => navStyle(isActive)}><span style={{ fontSize: '20px' }}>⚙️</span>Einstellungen</NavLink>
      </div>
    </div>
  );
}
